

<template>
    <div class="product-carousel product-carousel_type_catalog" id="product-element-carousel" style="max-width: 1150px;">
        <div class="product-carousel__title title title_size_md">
            Аналоги
        </div>
        <div class="product-carousel__list">
            <div class="product-carousel__list-container js-product-detail-carousel" :class="'s-' + itemId">
                <div class="product-carousel__list-wrapper swiper-wrapper">
                    <div v-for="item in items" class="swiper-slide product-carousel__list-item">
                        <div class="product product_view_box">
                            <div class="product__content-inner">
                                <div class="product__picture">
                                    <a :href="item.url" class="product__picture-preview">
                                        <img v-if="item.images.length > 0" :src="item.images[0]" alt="">
                                        <img v-else src="/upload/empty/300.png" alt="">
                                    </a>
                                </div>
                                <div class="product__main-info">
                                    <a :href="item.url" class="product__name">
                                       {{item.name}}
                                    </a>
                                </div>
                                <div v-if="user.isAuthorized" class="product__actions">
                                    <div class="product__prices">
                                        <div class="product__price product__price_type_old" v-if="item.price.price != item.price.stock">
                                            {{ Math.round(item.price.stock * item.step * 100) / 100  }} Р.
                                            <span class="percent-badge percent-badge_theme_yellow percent-badge_size_xs product__price-percent"
                                                  v-if="item.price.type=='MANUAL'">
                                              <span class="percent-badge__value">
                                                <vue-popper :id="item.id + '-el-percent'"
                                                            :hint="'Ваша перональная скидка на данную категорию товаров'">{{
                                                    item.price.percent
                                                  }}</vue-popper>
                                              </span>
                                            </span>
                                            <span
                                                    class="percent-badge percent-badge_theme_red percent-badge_size_xs product__price-percent"
                                                    v-else>
                                              <span class="percent-badge__value">{{ item.price.percent }}</span>
                                            </span>
                                        </div>
                                        <div class="product__price">
                                            {{ Math.round(item.price.price * item.step * 100) / 100  }} Р.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="swiper-pagination product-carousel__pagination"></div>
                <div class="swiper-arrow-next product-carousel__arrow product-carousel__arrow_next icon icon-arrow-long-left"></div>
                <div class="swiper-arrow-prev product-carousel__arrow product-carousel__arrow_prev icon icon-arrow-long-left"></div>
            </div>
        </div>
    </div>
</template>


<script>
    import VuePopper from "./VuePopper.vue";
    import Swiper, {Zoom,Navigation,Pagination,Lazy} from 'swiper';
    import "swiper/css";
    import "swiper/css/zoom";
    import "swiper/css/navigation";
    import "swiper/css/pagination";
    import "swiper/css/lazy";
    export default {
        name: "VueSwiperProducts",
        data: function () {
            return {
                swiperItems: {},
                isShow:false
            };
        },
        props: {
            items: Array,
            itemId: 0,
            user: {}
        },
        mounted: function () {
            this.isShow = true;
            new Swiper(".js-product-detail-carousel", {
                modules: [Pagination, Navigation, Zoom, Lazy],
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                },
                slidesPerView: 5,
                spaceBetween: 0,
                slidesPerGroup: 3,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".swiper-arrow-next",
                    prevEl: ".swiper-arrow-prev",
                },
                breakpoints: {
                    1119: {
                        slidesPerView: 4,
                    },
                    1019: {
                        slidesPerView: "auto",
                    },
                    320: {
                        slidesPerView: 1,
                    }
                },
            });
        },

        components: {
            VuePopper,
        }
    }

</script>